<template>
  <div class="container">
    <div><h3>Bekijk je shiften</h3></div>
    <label>
      <select v-model="selectedCustomerIndex" class="form-control">
        <option
            :key="customer.id" v-for="(customer, index) in customersWithShiftTypes"
            :value=index >{{ customer.name }}
        </option>
      </select>
    </label>
    <table class="table">
      <thead class="thead-dark">
      <tr>
        <SortableTableHeaderComponent
            columnName="name" :sortColumn="currentSortColumn"
            :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
            text="Naam shift"/>
        <SortableTableHeaderComponent
            columnName="labourTime" :sortColumn="currentSortColumn"
            :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
            text="Werkuren"/>
        <SortableTableHeaderComponent
            columnName="break" :sortColumn="currentSortColumn"
            :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
            text="Pauze-uren"/>
        <SortableTableHeaderComponent text="Actie"/>
      </tr>
      </thead>
      <tbody>
      <tr :key="shiftTypeDto.id" v-for="shiftTypeDto in sortedShiftTypes">
        <td :bgcolor="shiftTypeDto.color" :style="{color: giveTextColorForBackGroundColor(shiftTypeDto.color)}">
          {{ shiftTypeDto.name }}
        </td>
        <td>{{ timeIntervalToReadableFormat(shiftTypeDto.labourTime) }}</td>
        <td>{{ timeIntervalToReadableFormat(shiftTypeDto.breakTime) }}</td>
        <td>
          <button
              v-if="shiftTypeDto.contractShiftType"
              class="btn-basic btn-outline-pulse" @click="openEditShiftType(shiftTypeDto)">
            Shift type aanpassen
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="row d-block text-right">
      <button
          v-if="!showCreateShiftType"
          class="btn-basic btn-fill-pulse" @click="toggleCreateShiftType">Toevoegen
      </button>
      <button
          v-else
          class="btn-basic btn-fill-pulse-dark" @click="toggleCreateShiftType">Annuleren
      </button>
    </div>
    <div class="row" v-if="showCreateShiftType">
      <CreateShiftTypeAsUserComponent
          :customerId="this.selectedCustomerId" @shiftTypeAdded="toggleCreateShiftType"/>
    </div>
    <div class="row" v-if="showEditShiftType">
      <EditShiftTypeAsUserComponent
          :shiftTypeDtoToEdit="selectedShiftTypeDto"
          :customerId="this.selectedCustomerId" @shiftTypeEdited="closeEditShiftType"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import CreateShiftTypeAsUserComponent from "@/Admin/ShiftTypeComponent/CreateShiftTypeAsUserComponent";
import EditShiftTypeAsUserComponent from "@/Admin/ShiftTypeComponent/EditShiftTypeAsUserComponent";

export default {
  name: "CustomShift",
  components: {
    CreateShiftTypeAsUserComponent,
    EditShiftTypeAsUserComponent,
    SortableTableHeaderComponent
  },
  data: () => {
    return {
      breakHoursShow: false,
      selectedCustomerIndex: 0,
      selectedCustomerId: 0,
      isLoading: false,
      currentSortColumn: "labourTime",
      currentSortDirectionAscending: true,
      selectedShiftTypeDto: {},
      showCreateShiftType: false,
      showEditShiftType: false,
      shiftName: '',
      color: '',
      startTime: '',
      endTime: '',
      breakChecked: false,
      showBreakHours: false,
      breakStartTime: '',
      breakEndTime: '',
    };
  },
  computed: {
    ...mapGetters({
      customersWithShiftTypes: "timesheet/customersWithShiftTypes",
    }),
    sortedShiftTypes: function () {
      const customer = this.customersWithShiftTypes[this.selectedCustomerIndex];
      const shifTypeDtos = customer === undefined ? [] : customer.shiftTypeDtos;
      const shiftTypes = [...shifTypeDtos || []];

      if (this.currentSortColumn === "labourTime" || this.currentSortColumn === "break") {
        return sortListByColumnAndDirection(shiftTypes, this.currentSortColumn, this.currentSortDirectionAscending, this.timeIntervalToReadableFormat);
      }
      return sortListByColumnAndDirection(shiftTypes, this.currentSortColumn, this.currentSortDirectionAscending);
    },
  },
  created() {
    this.fetchShiftsOrderedByCustomer();
  },
  methods: {
    ...mapActions("timesheet", [
      'postShiftType',
      'fetchShiftsOrderedByCustomer'
    ]),
    async save() {
      this.isLoading = true;
      const createShiftTypeDto = {
        name: this.shiftName,
        color: this.color,
        labourTime: {
          startTime: this.startTime,
          endTime: this.endTime
        }
      };
      if (this.breakHoursShow && this.breakStartTime && this.breakEndTime) {
        createShiftTypeDto["break"] = {
          startTime: this.breakStartTime,
          endTime: this.breakEndTime,
        };
      }
      const customerId = this.customersWithShiftTypes[this.selectedCustomerIndex].id;
      await this.postShiftType({shift: createShiftTypeDto, customerId: customerId});
      this.isLoading = false;
      this.resetFormAndFields();
    },
    resetFormAndFields() {
      this.$refs.form.reset();
      this.startTime = "";
      this.endTime = "";
      this.shiftName = "";
      this.breakStartTime = "";
      this.breakEndTime = "";
      this.breakChecked = false;
      this.breakHoursShow = false;
    },
    toggleCreateShiftType() {
      this.selectedCustomerId = this.customersWithShiftTypes[this.selectedCustomerIndex].id;
      this.showCreateShiftType = !this.showCreateShiftType;
    },
    openEditShiftType(shiftTypeDto) {
      this.selectedShiftTypeDto = shiftTypeDto;
      this.selectedCustomerId = this.customersWithShiftTypes[this.selectedCustomerIndex].id;
      this.showEditShiftType = true;
    },
    closeEditShiftType() {
      this.showEditShiftType = false;
    },
    giveTextColorForBackGroundColor(color) {
      return giveTextColorForBackGroundColor(color);
    },
    timeIntervalToReadableFormat(interval) {
      if (interval) {
        return interval.startTime + " - " + interval.endTime;
      }
      return "/";
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  },
};
</script>

<style scoped>

</style>
